import {mapState} from 'vuex'

export default {
    computed: {
        human_dial_codes() {
            return this.dial_codes
                .map(code => {
                    code.human_value = `${code.dial_code} (${code.code})`;
                    return code;
                });
        },

        ...mapState(['dial_codes']),
    },

    mounted() {
        if(!this.dial_codes.length) {
            this.$store.dispatch('fetchDialCodes');
        }
    }

}
